import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-[#1A1A1A] py-12">
      <div className="container mx-auto px-6">
        <div className="bg-[#FDFBF7] rounded-3xl p-12">
          {/* Main Footer Content */}
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12">
            {/* Brand Column */}
            <div>
              <img
                src="https://static.readdy.ai/image/577c45d6defa6ac02f4bf39c73856fa0/3c52382db3d8225592af0a3213452f44.png"
                alt="Infinity Investment Property Solutions"
                className="h-12 w-auto mb-4"
              />
              <p className="text-sm text-[#6B6B6B] mb-3 font-medium">
                Southwest Michigan's Trusted Home Buyers
              </p>
              <p className="text-sm text-[#6B6B6B] leading-relaxed">
                We help homeowners sell their properties quickly and fairly with a simple, transparent process.
              </p>
            </div>

            {/* Quick Links */}
            <div>
              <h4 className="text-sm uppercase tracking-widest text-[#1A1A1A] font-semibold mb-6">
                Quick Links
              </h4>
              <ul className="space-y-3">
                {[
                  { path: '/how-it-works', label: 'How It Works' },
                  { path: '/why-choose-us', label: 'Why Choose Us' },
                  { path: '/situations', label: 'Situations' },
                  { path: '/about', label: 'About Us' }
                ].map((link) => (
                  <li key={link.path}>
                    <Link
                      to={link.path}
                      className="text-[#1A1A1A] hover:text-[#C9A961] transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Resources */}
            <div>
              <h4 className="text-sm uppercase tracking-widest text-[#1A1A1A] font-semibold mb-6">
                Resources
              </h4>
              <ul className="space-y-3">
                {[
                  { path: '/reviews', label: 'Reviews' },
                  { path: '/faq', label: 'FAQ' },
                  { path: '/contact', label: 'Contact' },
                  { path: '/contact', label: 'Get Offer' }
                ].map((link) => (
                  <li key={link.path + link.label}>
                    <Link
                      to={link.path}
                      className="text-[#1A1A1A] hover:text-[#C9A961] transition-colors cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-sm uppercase tracking-widest text-[#1A1A1A] font-semibold mb-6">
                Contact Us
              </h4>
              <ul className="space-y-4">
                <li className="flex items-start gap-3">
                  <i className="ri-phone-line text-xl text-[#C9A961] mt-1"></i>
                  <a href="tel:+12695551234" className="text-[#1A1A1A] hover:text-[#C9A961] transition-colors cursor-pointer">
                    (269) 555-1234
                  </a>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-mail-line text-xl text-[#C9A961] mt-1"></i>
                  <a href="mailto:info@infinityips.com" className="text-[#1A1A1A] hover:text-[#C9A961] transition-colors cursor-pointer">
                    info@infinityips.com
                  </a>
                </li>
                <li className="flex items-start gap-3">
                  <i className="ri-map-pin-line text-xl text-[#C9A961] mt-1"></i>
                  <span className="text-[#1A1A1A]">
                    Southwest Michigan<br />
                    Serving Kalamazoo, Battle Creek,<br />
                    Portage & Surrounding Areas
                  </span>
                </li>
              </ul>
            </div>
          </div>

          {/* Footer Bottom */}
          <div className="pt-8 border-t border-[#D4C5B9]">
            <div className="flex flex-col md:flex-row justify-between items-center gap-4">
              <p className="text-sm text-[#6B6B6B]">
                © {new Date().getFullYear()} Infinity Investment Property Solutions. All rights reserved.
              </p>
              <div className="flex items-center gap-6">
                <Link to="/privacy" className="text-sm text-[#6B6B6B] hover:text-[#C9A961] transition-colors cursor-pointer">
                  Privacy Policy
                </Link>
                <span className="text-[#D4C5B9]">|</span>
                <Link to="/terms" className="text-sm text-[#6B6B6B] hover:text-[#C9A961] transition-colors cursor-pointer">
                  Terms of Service
                </Link>
              </div>
              <div className="flex items-center gap-4">
                <a
                  href="https://facebook.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-[#C9A961] flex items-center justify-center text-white hover:bg-[#B8954E] transition-colors cursor-pointer"
                >
                  <i className="ri-facebook-fill text-lg"></i>
                </a>
                <a
                  href="https://linkedin.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="w-10 h-10 rounded-full bg-[#C9A961] flex items-center justify-center text-white hover:bg-[#B8954E] transition-colors cursor-pointer"
                >
                  <i className="ri-linkedin-fill text-lg"></i>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}